import React from 'react'
import { ReactComponent as TwoFactorSuccess } from '../../images/two_factor/two_factor_success.svg'
import { Button } from '@demandlocal/components'
import { useModal } from '../../components/useModal'
const TwoFactorSetupStepTwo = () => {
  const { closeModal } = useModal()
  return (
    <div className={'flex flex-col items-center justify-center h-full gap-8'}>
      <TwoFactorSuccess />
      <div className={'flex flex-col items-center gap-3'}>
        <h1 className={'text-3xl font-bold text-primary-xiketic'}>
          Two factor authentication enabled!
        </h1>
        <h3 className={'text-primary-xiketic text-base'}>
          You will now be prompted to enter a code from your authenticator app when you
          log in.
        </h3>
      </div>
    </div>
  )
}

export default TwoFactorSetupStepTwo
